<meta http-equiv="cache-control" content="no-cache" />
<meta http-equiv="Pragma" content="no-cache" />
<meta http-equiv="Expires" content="-1" />
<meta name="viewport" content="width=device-width, initial-scale=1">
<div class="container">

    <br>
      <div *ngIf="showDiv.next" class="hsscdiv row justify-content-center" [ngClass]="{ 'active':activeTab==='hsscResult'}">
        
        <div class="col-sm-6" >
          <div class="card bg-light">
            <div class="card-header">
              <h5 class="card-title" >
                <img src="/assets/board_logo.png" class="img" width="50px" height="50px">
                <u>ENTRANCE RESULT - 2021</u>
                
                </h5>
            </div>
            <div class="card-body">
             
              <form role="form" [formGroup]="selctform" (submit)="onStudentresulthssc()">
               
                  
                  <label for="staticEmail" class="col-form-label">Seat No</label>
                  <div class="">
                    <div class="form-group">
                      <input id="seat"  formControlName="seat"  placeholder="SEAT NO"  class="form-control" type="text" value="" >
                        
                    </div>
                  </div>
                  <label for="staticEmail" class="col-form-label">Birth Date</label>
                    <div class="">
                      <div class="form-group">
                        <input id="cdtbt"  formControlName="cdtbt"  placeholder="BIRTH DATE (DD/MM/YYYY)"  class="form-control" type="text" value="" >
                          
                      </div>
                    </div>
                    <label for="staticEmail" class="col-form-label" ><b>-------OR-------</b></label><BR>
                    <label for="staticEmail" class="col-form-label">Candidate’s Full Name</label>
                    <div class="">
                      <div class="form-group">
                        <input id="fname"  formControlName="fname"  placeholder="FULL NAME"  class="form-control" type="text" value="" >
                      </div>
                    </div>
                   
                    
                    <label for="staticEmail" class="col-form-label">Captcha</label>
                    <div class="form-group">
                      <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" [size]="size"
                      [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha" required>
                      </ngx-recaptcha2>
                    </div>
                    <!-- <label for="staticEmail" class="col-sm-8 col-form-label"><b>NOTE : Exam Year Format Like MARCH 2018</b></label> -->
                  
                    <div class="form-group" style="margin-top: -13px;">
                     
                        <!-- <button type="submit" class="btn btn-primary my-4" >Get Result</button>    -->
                        <button type="submit" [disabled]="isDisabled" class="btn btn-primary my-4">Get Result</button>
                      </div>
                 </form>
            </div>
        </div>  
        </div>
            
      
      </div>
        
    
<!--  -->
      <div class="row justify-content-center">
        <div class="col-sm-6" *ngIf="showDiv.hsscrslt;" >
          <h5 id="logo" class="card-title1">
            <img src="/assets/board_logo.png" class="img" width="50px" height="50px"> &nbsp;&nbsp;
            <b>Goa Board of Secondary and Higher Secondary   
              Education, Alto Betim, Goa 403 521.
          </b> <br></h5>
            
                    <div class="card">
                      <div class="card-header card-title">
                        ENTRANCE EXAM SCORE 2021 
                        <a [routerLink]="['/home']"><img src="/assets/back.png" class="backimg" height="30px" width="50px"></a>
                    </div>          
          <div class="row">
            <div class="col-md-12">
             
                <div class="card-body">
                
                   <div class="form-group row">
                    <label for="inputPassword" class="col-sm-4 col-form-label">Seat No</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" id="inputtext" value="{{seat}}" readonly>
                    </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassword" class="col-sm-4 col-form-label">Candidate’s Full Name </label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" id="inputtext" value="{{stname}}" readonly>
                    </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassword" class="col-sm-4 col-form-label">Father's Name </label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" id="inputtext" value="{{ftname}}" readonly>
                    </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassword" class="col-sm-4 col-form-label">Mother's Name</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" id="inputtext" value="{{mtname}}" readonly>
                    </div>
                    </div>
                    
                 <table id="qualify" class="table table-striped table-bordered table-sm row-border hover tblhssc" >
                  <thead>
                    <tr>
                      <td style="width:100px;text-align:left;"><b>Subject</b></td>
                      <td style="width:100px;"><b>Marks Obtained </b></td>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="subject">{{s1name}}</td>
                      <td>{{s1mks}}</td>
                      
                    </tr>
                    <tr>
                      <td  class="subject">{{s2name}}</td>
                      <td>{{s2mks}}</td>
                     
                    </tr>
                   
                    <tr>
                      <td class="subject">Total Marks</td>
                      <td>{{ttl}}</td>
                      
                    </tr>
                  </tbody>
              </table>
              <br>
                </div>
              </div>
                
            </div>
            <br>
        </div>
        <br>
        </div>
      </div>
 
    
</div>
